<template>
  <div>
    <div class="cube" @click="pointsLayerVisClick">
      <!-- <img src="../../assets/member/Hy.gif" alt=""> -->
    </div>
    <openMembership @memberHidden="memberHidden" v-if="isVisible" @isBuySuccess="isBuySuccess"
      @changeMemType="changeMemType" :memberType="memberType">
    </openMembership>

    <successRechart :onceNum="onceNum" :isvisib="isvisib" @isBuySuccess="isBuySuccess"></successRechart>
  </div>
</template>

<script>
import openMembership from '@/components/openMembership/index.vue'
import successRechart from '@/components/successRechart/index.vue'
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["GET_USER_INFO"]),
  },
  components: {
    openMembership,
    successRechart
  },
  data () {
    return {
      isVisible: false, //会员组件显示隐藏
      isvisib: false,
      onceNum: null,
      memberType: 2,
    }
  },
  methods: {
    pointsLayerVisClick () {

      if (this.GET_USER_INFO.token === '') { // 用户没登录
        this.$router.push({ path: '/member' })
      } else { // 用户已登录
        this.isVisible = true
      }
    },
    memberHidden (val) {
      this.isVisible = val
    },
    changeMemType (val) {
      this.onceNum = val
    },
    isBuySuccess (val) {
      this.isvisib = val
    },
  }
}
</script>

<style lang="less" scoped>
.cube {
  padding-top: 12px;
  padding-bottom: 16px;
  height: 120px;
  background-image: url('../../assets/member/kt2.gif');
  background-repeat: no-repeat;
  background-size: 100%;

}

.cube:hover {
  cursor: pointer;
}
</style>